"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(_ref) {
  var _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? function () {
    return true;
  } : _ref$filter;
  var offset = (page - 1) * pageSize;
  var filteredItems = dataSource.filter(filter);

  var pagedItems = _lodash.default.drop(filteredItems, offset).slice(0, pageSize);

  return {
    page: page,
    pageSize: pageSize,
    total: filteredItems.length,
    totalPages: Math.ceil(filteredItems.length / pageSize),
    data: pagedItems
  };
}